import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';

const AccountPlayerStats = ({ data, title }) => {
  const prefix = kebabCase(title);
  const rows = data.map((row, idx) => (
    <div key={`${prefix}-${idx}`} className='column medium-6 small-12'>
      <span className='u-txt--stat-player-value'>{Math.round(row.value)}</span><br />
      <span className='u-txt--stat-player-label'>{row.label}</span>
    </div>
  ));

  if (data.length > 1) {
    return (
      <div className='o-card__wrap'>
        <b>{title}</b>
        <section className='column o-card cs-bg--light'>
          <div className="row">
            {rows}
          </div>
        </section>
      </div>
    );
  }

  const row = data[0];

  return (
    <div className='o-card__wrap'>
      <b>{title}</b>
      <section className='column o-card cs-bg--light'>
        <div className="row">
          <div className='column medium-12 small-12 u-txt--center'>
            <span className='u-txt--stat-player-value'>{Math.round(row.value)}</span><br />
            <span className='u-txt--stat-player-label'>{row.label}</span>
          </div>
        </div>
      </section>
    </div>
  );
}

AccountPlayerStats.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
}

export default AccountPlayerStats;
